<template>
  <v-card
    elevation="0"
    class="card-box-shadow pa-0 w-100 h-100"
    style="border-radius: 10px; overflow-y: auto"
  >
    <v-card-title class="px-3 py-2 d-flex justify-space-between">
      <h5 class="text-caption mr-1 font-weight-bold">Driver Details</h5>
      <v-spacer />
      <v-icon
        color="primary"
        v-if="detailsObj.id"
        small
        @click="
          $router.push({
            name: 'driver-detail',
            params: { id: detailsObj.id },
          })
        "
        >mdi-eye</v-icon
      >
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle v-if="detailsObj && detailsObj.name || detailsObj.contact_number || detailsObj.shift_timing ">
      <v-row no-gutters>
        <v-col cols="6" class="pb-1" v-if="detailsObj.name">
          <TripTooltipWithIcon
            icon="mdi-account"
            :text="detailsObj.name"
            label="driver name"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="detailsObj.contact_number">
          <TripTooltipWithIcon
            icon="mdi-phone"
            :text="detailsObj.contact_number"
            label="driver contact number"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="detailsObj.shift_timing">
          <TripTooltipWithIcon
            icon="mdi-timer"
            :text="detailsObj.shift_timing"
            label="shift timing"
          />
        </v-col>
      </v-row>
    </v-card-subtitle>
     <v-card-subtitle v-else style="height:85px" class="d-flex justify-center align-center" >
      <h5 class="font-weight-light">Driver data not available</h5>
     </v-card-subtitle>
  </v-card>
</template>

<script>
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
export default {
  components: {
    TripTooltipWithIcon,
  },
  props: {
    detailsObj: {
      required: true,
    },
  },
};
</script>
